import React from 'react';
import InitialsSymbol from '../../../generic/User/initialsSymbol';
import {useTranslate} from "@tolgee/react";
import {useSelector} from "react-redux";

interface GroupMembersTooltipProps {
  group: any;
}
export const GroupMembersTooltip: React.FC<GroupMembersTooltipProps> = ({
  group
}) => {

  const {t} = useTranslate();

  const {
    data: { cloudUuid }
  } = useSelector((state: any) => state.lomavisPostApproval);

  return (
    <div className="w-100">
      {group.members.map((item) => (
        <div key={item.uuid} className="d-flex mb-4">
          <InitialsSymbol initials={item.initials} circle color={item.user_color || item.group_color} />
          <div className="ms-2 text-start">
            <div className="text-gray-800 text-hover-primary fw-bold w-100 text-truncate">
              {item.display_name}
            </div>
            <div className="text-gray-600">{cloudUuid ? item.role_cloud : item.role_cockpit}</div>
          </div>
        </div>
      ))}
    </div>
  );
};
